import { render, staticRenderFns } from "./EditArea.vue?vue&type=template&id=d3f519be"
import script from "./EditArea.vue?vue&type=script&lang=js"
export * from "./EditArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3f519be')) {
      api.createRecord('d3f519be', component.options)
    } else {
      api.reload('d3f519be', component.options)
    }
    module.hot.accept("./EditArea.vue?vue&type=template&id=d3f519be", function () {
      api.rerender('d3f519be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/pages/EditArea.vue"
export default component.exports